import { Component, Prop } from 'vue-property-decorator';
import { Component as TsxComponent } from 'vue-tsx-support';
import Dialog, { Slot } from 'components/dialog/Dialog';
import type { SyntheticEvent } from 'vue-tsx-support/types/dom';
import { ButtonColor, ButtonKind } from 'components/form/base-button/types';
import { Size } from 'components/types';
import Button from 'components/form/button/Button';

interface Props {
  isOpen: boolean;
}

interface Events {
  onCloseClick: (e: SyntheticEvent<HTMLElement, KeyboardEvent | MouseEvent>) => void;
  onUnassignConnectedShifts: (unassignFromConnected: boolean) => void;
}

@Component
export default class DialogUnassignConnected extends TsxComponent<Props, Events> {
  @Prop()
  public isOpen: Props['isOpen'];

  public render() {
    return (
      <Dialog
        isOpen={this.isOpen}
        onCloseClick={e => this.$emit('closeClick', e)}
      >
        {this.$t('shifts.employees.connectedShifts.explanationUnassign')}

        <Button
          color={ButtonColor.ERROR}
          size={Size.SMALL}
          type="button"
          kind={ButtonKind.GHOST}
          slot={Slot.BUTTONS_RIGHT}
          onClick={() => this.$emit('unassignConnectedShifts', false)}
          aria-label={this.$t('shifts.employees.connectedShifts.buttonUnassignSingle')}
        >
          {this.$t('shifts.employees.connectedShifts.buttonUnassignSingle')}
        </Button>

        <Button
          color={ButtonColor.SUCCESS}
          onClick={() => this.$emit('unassignConnectedShifts', true)}
          size={Size.SMALL}
          slot={Slot.BUTTONS_RIGHT}
          type="button"
          kind={ButtonKind.GHOST}
          aria-label={this.$t('shifts.employees.connectedShifts.buttonUnassignAll')}
        >
          {this.$t('shifts.employees.connectedShifts.buttonUnassignAll')}
        </Button>
      </Dialog>
    );
  }
}
